import Vue from 'vue'
import StorybookComponents from './storybook/storybook'
import WidgetComponents from './widgets/widgets'
import WidgetItemsComponents from './widgetItems/widgetItems'
import MCard from './mv/mvComponents'
import DynamicWidget from 'Components/DynamicWidget'
import '../lib/GlobalCss'
import '../assets/styles/index.css'
const Components = {
	...StorybookComponents,
	...WidgetComponents,
	...WidgetItemsComponents,
	...MCard,
	DynamicWidget
}

Object.keys(Components).forEach((name) => {
	Vue.component(name, Components[name])
})

export default Components
